import { useNavigate } from 'react-router-dom';
import illustration from '@/assets/customize-your-community.png';
import styles from './CustomizeYourCommunity.styles';
import {
  BodyLarge,
  ButtonOutlineLarge,
  TitleMediumEmphasized
} from '@/design-system';
import { APP_ROUTES } from '@/config/constants';

export const CustomizeYourCommunity: React.FC = () => {
  const navigate = useNavigate();
  const onExploreAllOportunity = () => {
    navigate(APP_ROUTES.community);
  }

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <TitleMediumEmphasized>
          Customize My Community
        </TitleMediumEmphasized>
      </div>
      <div className={styles.illustrationContainer}>
        <div className={styles.illustration}>
          <img
            src={illustration}
            alt="Customize your community"
            loading="lazy"
          />
        </div>
        <div className={styles.descriptionContainer}>
          <div className={styles.description}>
            <BodyLarge>
              Dial in your community area to be exposed
              to as many opportunities as possible.
            </BodyLarge>
          </div>
          <ButtonOutlineLarge onClick={onExploreAllOportunity}>
            Customize Your Community
          </ButtonOutlineLarge>
        </div>
      </div>
    </section>
  );
};

